import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Header from '../../components/Header';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import CaseStudies from './components/CaseStudies';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';
import './FrontPage.css';
const FrontPage = () => {
    return (_jsxs("div", { className: "frontpage", children: [_jsx(Header, { variant: "overlay" }), _jsxs("main", { children: [_jsx(Hero, {}), _jsx(Solutions, {}), _jsx(CaseStudies, {}), _jsx(Contact, {})] }), _jsx(Footer, {})] }));
};
export default FrontPage;
